import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { CountryStatusCssClasses } from "../CountriesUIHelpers";
import { useCountriesUIContext } from "../CountriesUIContext";

const selectedCountries = (entities, ids) => {
  const _countries = [];
  ids.forEach((id) => {
    const country = entities.find((el) => el.id === id);
    if (country) {
      _countries.push(country);
    }
  });
  return _countries;
};

export function CountriesFetchDialog({ show, onHide }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
    };
  }, [countriesUIContext]);

  // Countries Redux state
  const { countries } = useSelector(
    (state) => ({
      countries: selectedCountries(
        state.countries.entities,
        countriesUIProps.ids
      ),
    }),
    shallowEqual
  );

  // if countries weren't selected we should close modal
  useEffect(() => {
    if (!countriesUIProps.ids || countriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="timeline timeline-5 mt-3">
          {countries.map((country) => (
            <div className="timeline-item align-items-start" key={`id${country.id}`}>
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    CountryStatusCssClasses[country.status]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                    className={`label label-lg label-light-${
                      CountryStatusCssClasses[country.status]
                    } label-inline`}
                  >
                    ID: {country.id}
                </span>
                <span className="ml-3">{country.lastName}, {country.firstName}</span>                
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
